
import React from 'react';
import { useAuthContext } from './UltraSimpleAuthContext';
import { useAuthRedirects } from './hooks/useAuthRedirects';

/**
 * Component that handles auth redirects
 */
export const AuthRedirects: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuthContext();
  
  // Wrap in try-catch to ensure the component doesn't crash
  try {
    // This hook handles redirects based on auth state
    useAuthRedirects(user, isAuthenticated, isLoading);
  } catch (error) {
    console.error("[AuthRedirects] Error in redirect hook:", error);
  }
  
  // This component doesn't render anything
  return null;
};
